import {
    GET_FG_MODAL_FAILURE,
    GET_FG_MODAL_REQUEST,
  GET_FG_MODAL_SUCCESS,
  GET_FG_REPORT_DOWNLOAD_FAILURE,
  GET_FG_REPORT_DOWNLOAD_REQUEST,
  GET_FG_REPORT_DOWNLOAD_SUCCESS,
  GET_FG_REPORT_FAILURE,
  GET_FG_REPORT_REQUEST,
  GET_FG_REPORT_SUCCESS,
  GET_FG_TYPE_FAILURE,
  GET_FG_TYPE_REQUEST,
  GET_FG_TYPE_SUCCESS,
} from "./fgReportType";

const initialState = {
  loading: false,
  picklistAgeing: [],
  error: "",
};

const getFgReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_FG_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_FG_REPORT_SUCCESS:
      return {
        loading: false,
        picklistAgeing: action.payload,
        error: "",
      };
    case GET_FG_REPORT_FAILURE:
      return {
        loading: false,
        picklistAgeing: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateDownload = {
  loading: false,
  picklistAgeing: [],
  error: "",
};

const getFgReportDownloadReducer = (state = initialStateDownload, action) => {
  switch (action.type) {
    case GET_FG_REPORT_DOWNLOAD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_FG_REPORT_DOWNLOAD_SUCCESS:
      return {
        loading: false,
        picklistAgeing: action.payload,
        error: "",
      };
    case GET_FG_REPORT_DOWNLOAD_FAILURE:
      return {
        loading: false,
        picklistAgeing: [],
        error: action.payload,
      };
    default:
      return state;
  }
};
const initialStateForFGType = {
  loading: false,
  ageingParameter: [],
  error: "",
};

const getFGTypeReducer = (
  state = initialStateForFGType,
  action
) => {
  switch (action.type) {
    case GET_FG_TYPE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_FG_TYPE_SUCCESS:
      return {
        loading: false,
        ageingParameter: action.payload,
        error: "",
      };
    case GET_FG_TYPE_FAILURE:
      return {
        loading: false,
        ageingParameter: [],
        error: action.payload,
      };
    default:
      return state;
  }
};
const initialStateForFG = {
  loading: false,
  documents: [],
  error: "",
};

const getFGModalReducer = (state = initialStateForFG, action) => {
  switch (action.type) {
    case GET_FG_MODAL_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_FG_MODAL_SUCCESS:
      return {
        loading: false,
        documents: action.payload,
        error: "",
      };
    case GET_FG_MODAL_FAILURE:
      return {
        loading: false,
        documents: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export {
  getFgReportReducer,
  getFGTypeReducer,
  getFGModalReducer,
  getFgReportDownloadReducer
};
